module.exports = __webpack_public_path__ + "img/1572068003.ff83ecfd.jpg";